// extracted by mini-css-extract-plugin
export var closeButton = "_ce-1";
export var closeX = "_ce-3";
export var container = "_ce-0";
export var image = "_ce-2";